"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
require("./FieldSet.css");
/**
 * A container for grouping sets of fields similar to a HTML fieldset element.
 * A title and a checkbox will be rendered on the top border of the component.
 */
var FieldSet = /** @class */ (function (_super) {
    __extends(FieldSet, _super);
    function FieldSet(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Toggles the state according to the checkbox check state.
         */
        _this.onCheckChange = function (e) {
            if (_this.props.onCheckChange) {
                _this.props.onCheckChange(e);
            }
        };
        return _this;
    }
    FieldSet.prototype.render = function () {
        var _a = this.props, children = _a.children, checked = _a.checked, title = _a.title;
        return (React.createElement("fieldset", { className: "gs-fieldset" },
            React.createElement("legend", null,
                React.createElement(antd_1.Checkbox, { checked: checked, onChange: this.onCheckChange }, title)),
            React.Children.map(children, function (child, i) {
                // Ignore all childs if checkbox is unchecked
                if (checked) {
                    return child;
                }
                return undefined;
            })));
    };
    FieldSet.defaultProps = {
        checked: true
    };
    return FieldSet;
}(React.Component));
exports.FieldSet = FieldSet;
exports.default = FieldSet;
//# sourceMappingURL=FieldSet.js.map